import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";

const LOGO_URL = "/logo-sage.png";

export default function Footer() {
  return (
    <footer className="site-footer relative bg-[#262E12] py-16 z-[2]">
      <div className="container-if grid md:grid-cols-4 gap-10">
        <div>
          <img
            src={LOGO_URL}
            alt="Infantry Financial"
            className="h-16 w-auto mb-4 object-contain"
          />
          <p className="text-sm text-white/55 leading-relaxed" style={{ fontFamily: "Inter, sans-serif" }}>
            Military-precision credit restoration and financial consulting in Texas.
            CROA compliant. 90-day money-back guarantee.
          </p>
        </div>

        <div>
          <div className="font-mono-label text-[var(--if-gold)] mb-4">Navigate</div>
          <div className="flex flex-col gap-2 text-sm">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/services" className="nav-link">Services</Link>
            <Link to="/about" className="nav-link">About</Link>
            <Link to="/blog" className="nav-link">Blog</Link>
            <Link to="/ebook" className="nav-link" data-testid="footer-ebook-link">The Ebook — $4.99</Link>
            <Link to="/booking" className="nav-link">Book Consultation</Link>
            <Link to="/contact" className="nav-link">Contact</Link>
          </div>
        </div>

        <div>
          <div className="font-mono-label text-[var(--if-gold)] mb-4">Portal</div>
          <div className="flex flex-col gap-2 text-sm">
            <Link to="/login" className="nav-link">Client Login</Link>
            <Link to="/register" className="nav-link">Create Account</Link>
            <Link to="/dashboard" className="nav-link">Dashboard</Link>
          </div>
        </div>

        <div>
          <div className="font-mono-label text-[var(--if-gold)] mb-4">Contact HQ</div>
          <div className="flex flex-col gap-3 text-sm text-white/75" style={{ fontFamily: "Inter, sans-serif" }}>
            <span className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[var(--if-gold)]" /> Texas, USA</span>
            <span className="flex items-center gap-2"><Mail className="w-4 h-4 text-[var(--if-gold)]" /> infantryfinancial@gmail.com</span>
            <span className="flex items-center gap-2"><Phone className="w-4 h-4 text-[var(--if-gold)]" /> Available M-Sat · 9-5 CT</span>
          </div>
        </div>
      </div>

      <div className="container-if mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
        <div>© {new Date().getFullYear()} Infantry Financial. All rights reserved.</div>
        <div className="flex gap-5">
          <span>CROA Compliant</span>
          <span>FCRA Compliant</span>
          <span>Texas Based</span>
        </div>
      </div>
    </footer>
  );
}
